/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Gets the number of filter items
 * @param {object} localFilter the filter applied.
 * @return the number of filter items applied. If filter number is not applicable, return null
 */
export const getNumberOfFilterItems = function(localFilter) {
	if(localFilter) {
		if (localFilter.operator === 'in' ||
			localFilter.operator === 'notin' ||
			localFilter.operator === 'isnull') {
			return localFilter.values.length;
		}
	}
	return null;
};

// Scrollable drag constants
const SCROLL_DRAG_DISTANCE = 20;
export const handleScroll = function (e, scrollableContainer, onScrollCallback) {
	const boundingRect = scrollableContainer.getBoundingClientRect();
	const rect = {
		top: boundingRect.top,
		bottom: boundingRect.bottom
	};
	if(e.type === 'touchmove') {
		const coords = e.touches[0];
		if (coords) {
			e.clientX = coords.clientX;
			e.clientY = coords.clientY;
		}
	}
	if(!e.clientX || !e.clientY) {
		return;
	}
	const position = {
		x: e.clientX,
		y: e.clientY
	};
	const distanceBottom = rect.bottom - position.y;
	const distanceTop = position.y - rect.top;
	let isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
	let isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
	let distanceY = 0;
	if (isScrollingTop && isScrollingBottom) {
		isScrollingTop = distanceTop > distanceBottom;
		isScrollingBottom = !isScrollingTop;
	}
	if (isScrollingBottom) {
		distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
	} else if (isScrollingTop) {
		distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
	}
	let newScrollTop = scrollableContainer.scrollTop + distanceY;
	if(newScrollTop <= 0) {
		newScrollTop = 0;
	} else {
		const maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
		if(newScrollTop > maxScrollTop) {
			newScrollTop = maxScrollTop;
		}
	}
	if(scrollableContainer.scrollTop !== newScrollTop) {
		scrollableContainer.scrollTop = newScrollTop;
		if(onScrollCallback) {
			onScrollCallback();
		}
	}
};

/** this function returns datasource id that will be used in type in dropdown
 * it exercises following logic: 
 * 1. if there is active datasource id, use it
 * 2. else, use first datasource id in the list of datasources
 */
export const getDataSourceIdTypeIn = function (dashboardApi) {
	let sourceId = dashboardApi.getActiveDataSourceId();
	if (!sourceId) {
		const dataSourceFeature = dashboardApi.getFeature('DataSources');
		if (dataSourceFeature.getDataSourceList().length > 0) {
			sourceId = dataSourceFeature.getDataSourceList()[0].getId();
		}
	}
	return sourceId;
};


// WEBPACK FOOTER //
// ./src/js/utils.js